import React from 'react';
import { css } from '@emotion/react';

const IconButton = ({children, onClick, props}) => {
	return (
		<span css={iconStyle} onClick={onClick} role="button" {...props}>
			{children}
		</span>
	);
}

export default IconButton;

const iconStyle = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: "background 0.2s ease";
`;